const state = {
  snack: {
    level: null,
    msg: "",
  },
}

const mutations = {
  setSnack(state, payload) {
    state.snack.level = payload.level
    state.snack.msg = payload.msg
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
